"use strict";

document.addEventListener("DOMContentLoaded", function () {

	if (document.querySelector('.js-solar-lead-form')) {
		toggleRoofRenovation();

		document.querySelectorAll('input[name*=yearOfConstruction]')
			.forEach(input => input.addEventListener('change', toggleRoofRenovation));
	}

});

function toggleRoofRenovation() {
	const inputs = document.querySelectorAll('input[name*=renovationInPast30Years][type=radio]');

	if (inputs.length > 0) {

		if (document.querySelector('input[value=lessThanOneYear]').checked) {

			inputs.forEach(input => {
				input.disabled = true
				if (input.value === 'yes') {
					input.checked = true
					const hiddenInput = document.createElement('input')
					hiddenInput.type = 'hidden';
					hiddenInput.value = input.value;
					hiddenInput.name = input.name;
					input.closest('label').appendChild(hiddenInput);
				}
			})

		} else {

			inputs.forEach(input => {
				input.disabled = false

				if (input.value === 'yes') {
					const hiddenInput = input.closest('label').querySelector('input[type=hidden]');

					if (hiddenInput) {
						hiddenInput.remove();
					}

				}

			})

		}

	}

}
